import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import ListadoSuscripciones from './components/ListadoSuscripciones';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allSuscripcionesAction,
  setActivoSuscripcionesAction,
} from './SuscripcionesAction';
import { ModalComponent } from '../../../../widgets';
import FormSuscripciones from './components/FormSuscripciones';

const SuscripcionesView = () => {
  const dispatch = Redux.useDispatch();

  const suscripcionesStore = Redux.useSelector((state) => state.suscripciones);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoSuscripcionesAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoSuscripcionesAction(dispatch, null);
            await allSuscripcionesAction(dispatch, suscripcionesStore.params);
          }}
          disabled={
            suscripcionesStore.loadingAll || suscripcionesStore.all.length === 0
          }
          white
          refreshIcon
          text={
            suscripcionesStore.loadingAll ? 'Actualizando...' : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={12}>
        <ListadoSuscripciones
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </Grid>
      <ModalComponent
        id="modalFormSuscripciones"
        title={
          suscripcionesStore.activo
            ? `Editar ${suscripcionesStore.activo.entidad.nombre}`
            : 'Nueva suscripción'
        }
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormSuscripciones
          activo={suscripcionesStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default SuscripcionesView;
